import { Component, Input, OnInit, signal, SimpleChanges } from '@angular/core';
import { CoursesService } from '../../courses.service';
import { SignupModalService } from '../../signup-modal.service';
import { CheckoutModalService } from 'src/app/course/services/checkout-modal.service';
import { ProgressService } from 'src/app/progress.service';

@Component({
  selector: 'app-course-card',
  templateUrl: './course-card.component.html',
  styleUrls: ['./course-card.component.scss']
})
export class CourseCardComponent implements OnInit {

  @Input() course: any;
  @Input() purchased: boolean;
  percentageComplete = signal(0);

  public cheat = false;

  constructor(
    private coursesService: CoursesService,
    private signupModalService: SignupModalService,
    private checkoutModalService: CheckoutModalService,
    private progressService: ProgressService
  ) {
  }

  ngOnInit() {
    this.cheat = localStorage.getItem('testMode') === 'true'
    this.progressService.getUserProgressSummaryPercentageComplete(this.course.webAppId)
      .subscribe({
        next: (progress) => {
          if (progress) {
            this.percentageComplete.set(progress.percentageComplete);
          }
        },
        error: (error) => {
          console.error('Failed to load progress:', error);
        }
      });
  }

  toggleFavorite($event, course) {
    if (course.progress.userCourse == null) {
      this.coursesService.favorite(course, true);
      course.progress.userCourse = { favorite: true };
    } else if (course.progress.userCourse != null) {
      course.progress.userCourse.favorite = !course.progress.userCourse.favorite;
      this.coursesService.favorite(course, course.progress.userCourse.favorite);
    }
  }

  openCourse(course, userCourse) {
    this.coursesService.openCourse(course, userCourse);
  }


  go(url) {
    if (url != null) {
      window.location.replace(url);
    }
  }

  signup(course) {
    this.signupModalService.showSignupModal(course, {
      allowClose: true,
      onComplete: () => {
        this.coursesService.openCourse(course, null);
      }
    });
  }

  getCourseStatus() {
    if (this.course.status === 'HIDDEN' && this.purchased) {
      return 'card-course-PUBLISHED';
    }
    return 'card-course-' + this.course?.status
  }

  onBuyClick(event) {
    event.preventDefault();
    event.stopPropagation();

    this.checkoutModalService.buyCourse(this.course);
  }
}
